export class Communication {
  CommunicationID: number;
  CreatedBy: number;
  Subject: string;
  Department: string;
  CategoryId: number | null;
  SubCategoryId: number | null;
  CustomizationId: number | null;
  CustomizationImageId: number | null;
  CreatedOn: Date;
  Status: number;
  FileName: string;
  FilePath: string;
  Description: string;
  CommunicationType: string;
  BlockName: string;
  CommunicationTrackID: number;
  CustomCummunicationID: string;
  File: File;
  Name: string;
  ReplyMessage: string;
  ParentID: string;
  AgentFinalApprove: boolean;
  IsAgentApproved: number;
  Reason: string;
}
